//获取cookie
export function getCookie(name){
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return decodeURIComponent(arr[2]);
  else
    return null;
}
// 统一把 cookie 作用域固定在站点根路径。
//
// 为什么必须显式写 path=/：不写 path 时浏览器用「当前页面的默认路径」，
// 也就是当前 URL 去掉最后一段。路由表里既有 /login、/clientlogin 这种顶级登录页
// （默认路径正好是 /，所以一直没出问题），也有 /client/loginClient 这种嵌套登录页
// （默认路径是 /client）。从后者登录时，vid 只会落在 /client 上，
// 跳到 /dashboard 之类的页面就再也读不到 —— 请求拦截器拿不到 vid，
// VerifyId 请求头就发不出去，后端那道防 CSRF 校验等于没开。
//
// 同样的问题在删除侧更明显：delCookie 是在 MainTabBar（嵌套路由下的组件）里调的，
// 不带 path 时它只会在当前路径上写一个已过期的同名 cookie，
// 根本删不掉 / 上的那个，退出登录后 vid 会残留。
const COOKIE_PATH = "path=/";

//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value)
    + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
    + ";" + COOKIE_PATH;
};

//删除cookie
export function delCookie (name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";" + COOKIE_PATH;
}
